import Vue from 'vue'
import Vuex from 'vuex';
import main from './modules/main';
import index from './modules/main/index.js';
import ucenter from './modules/main/ucenter.js';
import login from './modules/main/login.js';


Vue.use(Vuex);

let store = new Vuex.Store({
	modules: {
		main,
		index,
		ucenter,
		login
	}
});

export default store;
